<template>
  <div class="performance-single-modal-mask">
      <div class="performance-single-modal-wrapper">
        <div class="performance-single-modal-container">

          <div class="performance-single-modal-header">
            <div>
              <h5>Performance agregada</h5>
            </div>
          </div>

          <div class="performance-single-modal-body">
            <div class="preview-modal">
              <div class="preview-img-data">
                <div class="offer" 
                :style="{'background-image': 'url(' + urlHost+item.images +')'}" alt="image"></div>
                <div class="preview-data">
                  <p class="title">{{item.name}}</p>
                  <p class="subtitle">{{item.description}}</p>
                  <div class="button sm secondary">
                    <p>{{item.button_text}}</p>
                </div>
                </div>
              </div>
              <div class="categories">
                <ul>
                  <li class="category" :class="catOne ? 'active' : ''">
                    <span class="img-cat category-1" :class="catOne ? 'active-cat-1' : ''"></span>
                    <p class="category-name">{{category_1}}</p>
                  </li>
                  <span class="divider"></span>
                  <li class="category" :class="catTwo ? 'active' : ''">
                    <span class="img-cat category-2" :class="catTwo ? 'active-cat-2' : ''"></span>
                    <p class="category-name">{{category_2}}</p>
                  </li>
                  <span v-if="category_3" class="divider"></span>
                  <li v-if="category_3" class="category" :class="catThree ? 'active' : ''">
                    <span class="img-cat category-3" :class="catThree ? 'active-cat-3' : ''"></span>
                    <p class="category-name">{{category_3}}</p>
                  </li>
                  <span v-if="category_4" class="divider"></span>
                  <li v-if="category_4" class="category" :class="catFour ? 'active' : ''">
                    <span class="img-cat category-4" :class="catFour ? 'active-cat-4' : ''"></span>
                    <p class="category-name">{{category_4}}</p>
                  </li>
                </ul>
              </div>

            </div>

            <div class="performance">
              <div class="revenue">
                <h6 class="subtitle">Revenue (Últimos 30 días)</h6>
                <div class="counter">
                  <h4 class="value">$ {{actualRevenue}}</h4>
                </div>
              </div>
              <!-- <hr>
              <div class="interactions-venue">
                <h6 class="subtitle">Interacciones por sucursal</h6>
                <ul class="ranking-venue">

                  <li class="spot">
                    <small class="venue-name">{{venueName}}</small>
                    <small class="venue-interactions">{{venueInteractions}}</small>
                  </li> 
                </ul>
              </div> -->
              <hr>
              <!-- <div class="engagement">
                <h6 class="subtitle">Engagement</h6>
                <h4 class="value">{{engagement}}</h4>
              </div> 
              <hr>-->
              <div class="vigencia">
                <h6 class="subtitle">Vigencia</h6>
                <h4 class="days-count">{{daysCount ? daysCount+ ' días' : 'Indefinido'}}</h4>
                <small class="dates" v-if="item.end_date">desde el {{item.init_date}} al {{item.end_date}}</small>
                <small class="dates" v-else>desde el {{item.init_date}}</small>
              </div>
              <hr>
              <small class="created">Creada: {{item.init_date}}</small>
            </div>
              
          </div>

          <div class="performance-single-modal-footer">
            <button class="button md ghost black" @click="hideCreatedModal">
              <p>Cerrar</p>
            </button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: 'performance-modal',
  components:{},
  props: {
    actualRevenue: {
      type: String,
      default: ""
    },
    venueName: {
      type: String,
    },
    venueInteractions: {
      type: String,
    },
    engagement: {
      type: String,
      default: "35%"
    },
    fromDate: {
      type: String,
    },
    toDate: {
      type: String,
    },
    created: {
      type: String,
    },
    item: {
      type: Object,
      required: true
    },
    catOne: {
      type: Boolean,
      required: true
    },
    catTwo: {
      type: Boolean,
      required: true
    },
    catThree: {
      type: Boolean,
      required: true
    },
    catFour: {
      type: Boolean,
      required: true
    },
    category_1:{
      type: String,
      required: true
    },
    category_2:{
      type: String,
      required: true
    },
    category_3:{
      type: String,
      required: true
    },
    category_4:{
      type: String,
      required: true
    },
    daysCount: {
      type: Number,
      required: true
    }
  },
  methods: {
    hideCreatedModal: function(){
      this.$emit('closeCreatedModal');
      this.$router.push({path:'/ofertas/gestion'})
    },
  },
  computed: {
        urlHost: function() {
            console.log(process.env.VUE_APP_CORE_HOST)
            return process.env.VUE_APP_CORE_HOST
        }
    }
}
</script>

<style lang="sass">
.performance-single-modal-mask
  font-family: Montserrat
  position: fixed
  z-index: 99998
  top: 0
  left: 0
  width: 100%
  height: 100%
  background-color: rgba(0, 0, 0, .5)
  display: table
  transition: opacity .3s ease
  text-align: center
.performance-single-modal-wrapper
  display: table-cell
  vertical-align: middle
.performance-single-modal-container
  max-width: 600px
  border-radius: 8px
  box-shadow: 0 2px 10px 0 rgba(173, 182, 212, 0.45)
  background-color: #ffffff
  margin: 0 auto
  padding: 24px 12px
  transition: all .3s ease
  @media (max-width: $tablet)
    max-width: calc(100% - 40px)
    margin: 0 8px
.performance-single-modal-header
  text-align: left
.performance-single-modal-header i
  color: #c90b2f
  font-size: 72px
.performance-single-modal-body 
  text-align: left
  margin: 20px 0
.performance-single-modal-body p
  font-size: 16px
  font-family: $body-font
  margin-bottom: 16px
.performance-single-modal-footer
  width: 100%
  display: flex
  justify-content: center
.performance-single-modal-footer .button
  margin: 8px
.modal-enter
  opacity: 0
.modal-leave-active
  opacity: 0
.modal-enter .active-modal-container,
.modal-leave-active .active-modal-container
  -webkit-transform: scale(1.1)
  transform: scale(1.1)
.performance-single-modal-body
  display: flex
  flex-direction: row
  justify-content: space-between
  .performance
    display: flex
    flex-direction: column
    width: 50%
    hr
      width: 50%
      align-self: center
      margin: $sm 0
      opacity: 0.6
      height: 0px
      border: 0.5px solid $dark-grey
    h4
      width: 100%
      text-align: right
    small
      font-family: $body-font
    .revenue
      font-family: $title-font
      .counter
        display: flex
        flex-direction: row
        margin-top: $sm
        i
          margin-top: $xxs
      .value
        flex-grow: 2
        text-align: right
      .pre-value
        flex-grow: 2
        width: 100%
        text-align: right
        font-size: 14px
    .ranking-venue 
      margin-top: $sm
      .spot
        display: flex
        width: 100%
        margin-top: $xxs
        .venue-name
          flex-grow: 3
        .venue-interactions
          flex-grow: 1
          text-align: right
    .vigencia
      display: flex
      flex-direction: column
      .dates
        width: 100%
        text-align: right
        margin-top: 2px
    .created
      diplay: flex
      width: 100%
      text-align: center
      margin-bottom: $sm

  .preview-modal
    display: flex
    flex-direction: column
    width: 40%
    position: relative
    height: 480px
    justify-content: space-between
    align-content: space-between
    .preview-img-data
      margin-top: $xs
      display: flex
      height: 80%
      position: relative
      .offer
        position: absolute
        z-index: 1
        order: 1
        width: 100%
        height: 100%
        background-size: cover
      .preview-data
        font-family: $body-font
        display: flex
        flex-direction: column-reverse
        align-items: flex-end
        box-sizing: border-box
        position: absolute
        width: 100%
        height: 100%
        background-image: linear-gradient(180deg, rgba(0,0,0,0.00) 0%, rgba(0,0,0,0.75) 72%)
        z-index: 2
        border-radius: 4px
        overflow: hidden
        .title
          font-weight: bold
          font-size: 16px
          text-align: right
          width: 100%
          color: $white
          order: 3
          padding: 0px 8px
          box-sizing: border-box
          margin-bottom: 0px
        .subtitle
          text-align: right
          width: 100%
          font-weight: 200
          color: $white
          order: 2
          font-size: 12px
          padding: 0px 8px
          margin-top: $xs
          margin-bottom: $md
          box-sizing: border-box
        .button
          order: 1
          margin-bottom: $sm
          width: 60%
          margin-left: auto
          margin-right: auto
          p
            font-size: 12px

    .categories
      flex-grow: 1
      display: flex
      flex-direction: row
      align-items: center
      width: 100%
      height: 20%
      background: $white
      ul
        display: flex
        justify-content: space-evenly
        width: 100%
        align-items: flex-start
        list-style-type: none
        align-self: center
        background-color: $white
        padding: 4px
        li
          align-items: center
          .img-cat
            width: 32px
            height: 32px
            display: block
            background-position: 0% 0% 
            margin-bottom: $xs
          .category-1
            background: url(../../assets/icons/categories/cat-01-in.svg) no-repeat center
          .category-2
            background: url(../../assets/icons/categories/cat-02-in.svg) no-repeat center
          .category-3
            background: url(../../assets/icons/categories/cat-03-in.svg) no-repeat center
          .category-4
            background: url(../../assets/icons/categories/cat-04-in.svg) no-repeat center
          .active-cat-1
            background: url(../../assets/icons/categories/cat-01-ac.svg) no-repeat center
          .active-cat-2
            background: url(../../assets/icons/categories/cat-02-ac.svg) no-repeat center
          .active-cat-3
            background: url(../../assets/icons/categories/cat-03-ac.svg) no-repeat center
          .active-cat-4
            background: url(../../assets/icons/categories/cat-04-ac.svg) no-repeat center
      .divider
        width: 1px
        height: 24px
        border: none
        display: flex
        background: $secondary
        border-radius: 8px
      .category
        flex-grow: 1
        display: flex
        flex-direction: column
        opacity: 0.6
        width: 30%
        .category-name
          font-family: $title-font
          font-size: 10px
          text-align: center
          font-weight: bold
          margin-bottom: $xs
        &.active
          color: $secondary
          opacity: 0.6
</style>


